import React, { useEffect, useMemo } from 'react';
import * as Yup from "yup";
import NotificationSettingForm from './NotificationSettingForm'
import { CircularProgress, Paper, withStyles } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as actions from "./store/notificationSettingActions";
import History from "../../../History";
import { getFormattedPossibleNotifications } from './utils';

const styles = theme => ({
    root: {
        width: `99.1%`,
        height: 'auto',
        margin: '7px',
        marginBottom: 0,
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const NotificationSettingEdit = props => {
    const { notificationSetting, customers, loading, classes, onFetchNotificationSettingInit, activeCustomer, translations, permissions, loadingNotificationSetting } = props;

    const possibleNotifications = getFormattedPossibleNotifications(translations);
    const extractType = selectedType => {
        return selectedType.map(type => type.value);
    }

    const formatSelectedType = useMemo(() => {
        let selectedTypes = notificationSetting?.Type?.split(';');
        if (!selectedTypes) {
            return [];
        }
        return possibleNotifications.filter(possibleType => selectedTypes.includes(possibleType.value));
    }, [notificationSetting, possibleNotifications]);

    const handleSubmit = async data => {
        let objToSend = { ...data }
        objToSend['Type'] = extractType(data.Type)
        objToSend['CustomerID'] = data['CustomerID'] === '' ? null : data['CustomerID'];
        objToSend['NotificationSettingID'] = notificationSetting.NotificationSettingID;
        let result = await props.onEditNotificationSetting({ ...objToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    }

    const cancelHandler = () => {
        History.goBack();
    };

    useEffect(() => {
        const fetchData = async () => {
            await props.onFetchNotificationSetting({ ActiveCustomerID: activeCustomer, NotificationSettingID: parseURL(window.location.href).notificationSettingID })
        }
        fetchData();
        return () => {
            onFetchNotificationSettingInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let initialValues = {
        Receivers: notificationSetting.Receivers || '',
        Type: formatSelectedType,
        CustomerID: notificationSetting.CustomerID || ''
    };

    let formSettings = {
        Validation: {
            Receivers: Yup.string().required("Required"),
            Type: Yup.array().required("Required")
        },
        FormTitle: translations['edit_notification_setting'] || 'Edit notification setting',
        ButtonSubmit: hasPermission(permissions, "notification_setting_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
        ButtonCancel: {
            Title: translations["cancel"] || "Cancel",
            handleCancel: cancelHandler
        }
    };

    return (
        loadingNotificationSetting ? <CircularProgress /> :
            <Paper className={classes.root}>
                {BackButton(translations)}
                <NotificationSettingForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    customers={customers}
                    possibleNotifications={possibleNotifications}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                ></NotificationSettingForm>
            </Paper>)
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        customers: state.core.login.customers,
        notificationSetting: state.setting.notificationSettings && state.setting.notificationSettings.loaded ? state.setting.notificationSettings.loaded : {},
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        loading: state.setting.notificationSettings.editing,
        loadingNotificationSetting: state.setting.notificationSettings.loading
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchNotificationSettingInit: notificationSetting => dispatch(actions.loadNotificationSettingInit(notificationSetting)),
        onFetchNotificationSetting: notificationSetting => dispatch(actions.loadNotificationSetting(notificationSetting)),
        onEditNotificationSetting: notificationSetting => dispatch(actions.editNotificationSetting(notificationSetting)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(NotificationSettingEdit));
